import axios from 'axios';
import { dropToken } from './token';
import { LOGIN_ROUTE } from './consts/pathRoutes';

/**
 * Обработка истёкшего токена.
 *
 * До появления `expiresIn` на сервере токен жил вечно, и 401 в норме не приходил.
 * Теперь приходит — и без этого перехватчика пользователь увидел бы не форму входа,
 * а набор непонятных ошибок на каждом запросе.
 *
 * Перехватчик вешается на глобальный axios: большинство экшенов вызывают `axios.get`
 * напрямую, а не через экземпляр из utils/api.js.
 */
export const setupAuthInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const isLoginRequest = error.config?.url?.includes('/api/auth/login');

      if (status === 401 && !isLoginRequest) {
        dropToken();

        // Router здесь недоступен — перехватчик живёт вне дерева компонентов.
        if (window.location.pathname !== LOGIN_ROUTE) {
          window.location.assign(LOGIN_ROUTE);
        }
      }

      return Promise.reject(error);
    }
  );
};
